import { render, staticRenderFns } from "./BonusKnowledge.vue?vue&type=template&id=ff48a26e&scoped=true&"
import script from "./BonusKnowledge.vue?vue&type=script&lang=js&"
export * from "./BonusKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./BonusKnowledge.vue?vue&type=style&index=0&id=ff48a26e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff48a26e",
  null
  
)

/* custom blocks */
import block0 from "./BonusKnowledge.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports